import { S as Swiper, N as Navigation, a as Scrollbar, M as Mousewheel } from "./scrollbar.chunk.js";
const colectionButttonsSwiper = new Swiper("#jc-subcollection-swiper", {
  modules: [Navigation, Scrollbar, Mousewheel],
  slidesPerView: "auto",
  spaceBetween: 0,
  threshold: 10,
  direction: "horizontal",
  touch: true,
  mousewheel: {
    forceToAxis: true,
  },
  // scrollbar: {
  //   el: '#jc-subcollection-swiper-scroll',
  //   draggable: true,
  //   hide: true,
  // },
});
colectionButttonsSwiper.on("click", function (swiper, event) {
  var clickedIndex = swiper.clickedIndex;
  swiper.slideTo(clickedIndex);
});
const acc = document.querySelectorAll(".jc-filter-accordion-title");
acc.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.target.closest(".jc-filter-accordion-title").classList.toggle("active");
    const paper = e.target.closest(".jc-filter-accordion");
    const content = paper.querySelector(".jc-filter-accordion-content");
    if (content.style.maxHeight != "0px") {
      content.style.maxHeight = "0px";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});
window.addEventListener("mousemove", accordionMove);
window.addEventListener("scroll", accordionMove);
window.addEventListener("resize", accordionMove);
function accordionMove() {
  document.querySelectorAll(".jc-filter-accordion-content").forEach((item) => {
    if (item.style.maxHeight != "0px") {
      item.style.maxHeight = item.scrollHeight + "px";
    }
  });
}
const collectionProductsTop = document.getElementById("jc-collection-list-top");
const collectionProductsTopOverlay = document.getElementById("jc-collection-list-top__overlay");
function moveFiltersBlock() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  if (viewportWidth < 992) {
    let filtersBlock = document.getElementById("jc-filters-wrap");
    if (filtersBlock && collectionProductsTop) {
      collectionProductsTop.appendChild(filtersBlock);
    }
  } else {
    let filtersBlock = document.getElementById("jc-filters-wrap");
    const jcFiltersBlock = document.getElementById("jc-filters");
    if (filtersBlock && jcFiltersBlock) {
      jcFiltersBlock.appendChild(filtersBlock);
    }
    if (collectionProductsTop) {
      collectionProductsTop.classList.remove("active");
    }
    if (collectionProductsTopOverlay) {
      collectionProductsTopOverlay.classList.add("jc-hidden");
    }
  }
}
const openButton = document.getElementById("jc-filters-wrap__toggle");
if (openButton) {
  openButton.addEventListener("click", function () {
    if (window.innerWidth < 992) {
      if (collectionProductsTop) {
        collectionProductsTop.classList.add("active");
      }
      if (collectionProductsTopOverlay) {
        collectionProductsTopOverlay.classList.remove("jc-hidden");
      }
      if (collectionProductsTop) {
        collectionProductsTop.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });
}
const closeButton = document.querySelectorAll(".jc-hide-filter");
closeButton.forEach((btn) => {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    if (collectionProductsTop) {
      collectionProductsTop.classList.remove("active");
    }
    if (collectionProductsTopOverlay) {
      collectionProductsTopOverlay.classList.add("jc-hidden");
    }
  });
});
document.addEventListener("DOMContentLoaded", moveFiltersBlock);
window.addEventListener("resize", moveFiltersBlock);
const form = document.getElementById("subFiltersForm");

// Fonction pour appliquer les filtres depuis l'URL au chargement de la page
function applyFiltersFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const filterParams = [];

  // Collecter tous les paramètres de filtres
  for (const [key, value] of urlParams.entries()) {
    if (key.startsWith("filter.")) {
      filterParams.push(`${key}=${value}`);
    }
  }

  if (filterParams.length > 0) {
    const requestUrl = filterParams.join("&");
    handleFilters(requestUrl);
  }
}

// Fonction pour synchroniser les checkboxes avec les paramètres URL
function syncCheckboxesWithURL() {
  if (!form) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);

  // Parcourir tous les éléments du formulaire
  for (let i = 0; i < form.elements.length; i++) {
    let element = form.elements[i];

    if (element.type === "checkbox" || element.type === "radio") {
      const paramName = decodeURIComponent(element.name);
      const paramValue = decodeURIComponent(element.value);

      // Vérifier si ce paramètre existe dans l'URL
      if (urlParams.has(paramName)) {
        const urlValue = urlParams.get(paramName);

        if (urlValue === paramValue) {
          element.checked = true;
        }
      } else {
        // Vérifier aussi avec les paramètres encodés
        const encodedParamName = encodeURIComponent(paramName);
        if (urlParams.has(encodedParamName)) {
          const urlValue = urlParams.get(encodedParamName);

          if (urlValue === paramValue) {
            element.checked = true;
          }
        }
      }
    }
  }
}

// Masquer les produits dès le chargement si il y a des filtres dans l'URL
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const hasFilters = Array.from(urlParams.keys()).some((key) => key.startsWith("filter."));

  if (hasFilters && document.body) {
    // Ajouter la classe de chargement au body
    document.body.classList.add("jc-loading-filters");
  }
});

window.onload = function () {
  // Synchroniser les checkboxes avec l'URL
  syncCheckboxesWithURL();

  // Appliquer les filtres depuis l'URL
  applyFiltersFromURL();

  // Ajouter les event listeners
  if (form) {
    for (let i = 0; i < form.elements.length; i++) {
      let element = form.elements[i];
      element.addEventListener("change", handleChange);
    }
  }
};
function handleChange(event) {
  if (!form) {
    return;
  }

  let element = event.target;
  let nonEmptyElements = [];
  for (let i = 0; i < form.elements.length; i++) {
    element = form.elements[i];
    let queryItem = element.name + "=" + element.value;
    if (element.type === "checkbox" || element.type === "radio") {
      if (element.checked) {
        nonEmptyElements.push(queryItem);
      }
    }
  }
  let requestUrl = nonEmptyElements.join("&");

  // Mettre à jour l'URL avec les nouveaux paramètres
  updateURLWithFilters(requestUrl);

  handleFilters(requestUrl);
}

// Fonction pour mettre à jour l'URL avec les filtres
function updateURLWithFilters(filterParams) {
  const url = new URL(window.location);
  const searchParams = new URLSearchParams();

  // Ajouter les paramètres de filtres
  if (filterParams) {
    const params = filterParams.split("&");
    params.forEach((param) => {
      const [key, value] = param.split("=");
      if (key && value) {
        searchParams.set(key, value);
      }
    });
  }

  // Ajouter le filtre de disponibilité par défaut
  if (!searchParams.has("filter.v.availability")) {
    searchParams.set("filter.v.availability", "1");
  }

  // Mettre à jour l'URL
  url.search = searchParams.toString();
  window.history.replaceState({}, "", url.toString());
}
const subColections = document.querySelectorAll("[data-subcollection-handle]");
function handleFilters(newURL) {

  //demande de l'équipe de Yade: Toujours afficher les produits disponibles
  if (!newURL.includes("filter.v.availability")) {
    newURL += "&filter.v.availability=1";
  }

  document.querySelectorAll("[jolly-card-id]").forEach((card) => {
    card.classList.remove("jc-filtered");
  });

  subColections.forEach((subCollection) => {
    subCollection.classList.add("jc-subcollection-filtered");
    subCollection.classList.add("jc-hidden");
    let jolly_subcollection_handle = subCollection.dataset.subcollectionHandle;

    let parser = new DOMParser();
    fetch(window.location.origin + `/collections/${jolly_subcollection_handle}?${newURL}`)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        let parsedData = parser.parseFromString(data, "text/html");
        let collectionProductsElement = parsedData.getElementById("collectionProducts");

        if (!collectionProductsElement) {
          return;
        }

        let newItems = collectionProductsElement.innerText;

        const subCollectionCard = subCollection.querySelectorAll("[jolly-card-id]");

        if (subCollectionCard.length == 0) {
          return;
        }

        let visibleCards = 0;
        subCollectionCard.forEach((el) => {
          let cardFilter = el.getAttribute("jolly-card-id");
          if (newItems.indexOf(cardFilter) != -1) {
            el.classList.add("jc-filtered");
            el.classList.remove("jc-hidden");
            visibleCards++;
          } else {
            el.classList.remove("jc-filtered");
            el.classList.add("jc-hidden");
          }
        });

        if (visibleCards > 0) {
          subCollection.classList.remove("jc-hidden");
        } else {
          subCollection.classList.add("jc-hidden");
        }
      })
      .catch((error) => {
        // Erreur silencieuse pour ne pas polluer la console
      });
  });

  // Rendre visible tous les produits après le filtrage
  setTimeout(() => {
    if (document.body) {
      document.body.classList.remove("jc-loading-filters");
      document.body.classList.add("jc-filters-loaded");
    }
  }, 200);
}

const sectionHeader = document.querySelector(".header-group-container");
const collectionListTop = document.getElementById("jc-collection-list-top");
if (sectionHeader && collectionListTop) {
  const sectionHeaderObserver = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const sectionHeaderHeight = sectionHeader.offsetHeight;
        const sectionHeaderElement = sectionHeader.querySelector(".section-header");
        if (sectionHeaderElement) {
          if (sectionHeaderElement.classList.contains("shopify-section-header-hidden")) {
            collectionListTop.style.top = `0px`;
          } else {
            collectionListTop.style.top = `${sectionHeaderHeight}px`;
          }
        }
      }
    }
  });
  sectionHeaderObserver.observe(sectionHeader, { attributes: true });
}

